"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForbiddenResponse = void 0;
const class_validator_jsonschema_1 = require("class-validator-jsonschema");
const class_validator_1 = require("class-validator");
const standard_response_1 = require("./../standard.response");
const forbidden_exception_1 = require("./../../exceptions/forbidden.exception");
let ForbiddenResponse = class ForbiddenResponse extends standard_response_1.StandardResponse {
};
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", forbidden_exception_1.ForbiddenException)
], ForbiddenResponse.prototype, "data", void 0);
ForbiddenResponse = __decorate([
    (0, class_validator_jsonschema_1.JSONSchema)({
        description: 'If you try to access to a resource without the good scope',
    })
], ForbiddenResponse);
exports.ForbiddenResponse = ForbiddenResponse;
